const tooltipFormService = {
  goToPlace: 'Go to location details',
  goToEquipment: 'Go to equipment details'
};

export default tooltipFormService;
